export default __webpack_public_path__ + "static/media/furaha.a9825c61.jpg";